module.exports = __webpack_public_path__ + "img/icone_vazamento_interno.a5c3eedb.png";